import {Flow} from '@ampeco/charge-flow';

export default class RegisterFlow extends Flow {
    protected collectSteps() {
        this.steps.push('Register');
        this.steps.push('ContactDetails');
    }
}
